import { Entity25D } from '../../display/odie25d/Entity25D';
import { Game } from '../Game';

export class BaseEntity<T = any> extends Entity25D<T>
{
    public get game(): Game | undefined
    {
        return this.scene as Game;
    }
}
